import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/images/icon.png"
      width="20"
      {...props}
    />
  );
};

export default Logo;
